
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-municipals-28m-2023/debat",
      function () {
        return require("private-next-pages/3catinfo/eleccions-municipals-28m-2023/debat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-municipals-28m-2023/debat"])
      });
    }
  